import { SubAPI } from "./SubAPI";
export class QuoteDiv10 extends SubAPI {
    replaceProducts(input) { return this.fetcher.post("/api/quote-div-10/replace-product", input); }
    list(props) { return this.fetcher.get("/api/quote-div-10", props); }
    summary(props) { return this.fetcher.get("/api/quote-div-10/summary", props); }
    upsert(props) { return this.fetcher.post("/api/quote-div-10", props); }
    reOrder(props) { return this.fetcher.post("/api/quote-div-10/re-order", props); }
}
